import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  paymentRequestLabel: string
  transfersCount: number
  isLoading: boolean
  onConfirm: () => void
  onClose: () => void
}

export const ConfirmRemovePaymentRequestModal = ({
  paymentRequestLabel,
  transfersCount,
  isLoading,
  onConfirm,
  onClose,
}: Props) => {
  return (
    <Modal
      title={i18n.t('banking.bulkPayments.detail.removeConfirmModal.title')}
      description={
        <Box flexDirection="column" gap="s8">
          <Text.Normal>
            <Text.Normal weight="semibold">{paymentRequestLabel}</Text.Normal>{' '}
            {i18n.tp('banking.bulkPayments.detail.transfersCount', { count: transfersCount })}
          </Text.Normal>
          <Text.Normal>
            {i18n.t('banking.bulkPayments.detail.removeConfirmModal.description')}
          </Text.Normal>
        </Box>
      }
      illustration="alert"
      onClose={onClose}
      onSubmit={onConfirm}
      footer={
        <Box flexDirection="row" gap="s16">
          <Button type="secondary" onClick={onClose} disabled={isLoading}>
            {i18n.t('banking.bulkPayments.detail.removeConfirmModal.cancel')}
          </Button>
          <Button submit onClick={onConfirm} disabled={isLoading}>
            {isLoading
              ? i18n.t('common.loading')
              : i18n.t('banking.bulkPayments.detail.removeConfirmModal.confirm')}
          </Button>
        </Box>
      }
    />
  )
}
